import './index.css';
import './i18n';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { createRoot } from "react-dom/client";
import { StrictMode } from 'react';
 import { HelmetProvider } from 'react-helmet-async';

createRoot(document.getElementById("root")!).render(
    <StrictMode>
      <HelmetProvider>
        <App />
      </HelmetProvider>
    </StrictMode>
  );

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
